@use 'ui/styles/core-tokens' as core;

.container {
  height: 100%;
  margin: 0 auto;
  position: relative;
}
